var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.998 344.847C129.998 344.847 188.113 461.564 321.956 415.432C321.956 415.432 375.152 397.626 399.261 344.63L359.713 344.458C359.713 344.458 256.599 491.749 129.998 344.847Z",
    fill: "#2C44BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.96 346.369C119.96 346.369 149.904 461.398 300.18 455.266C300.18 455.266 406.521 448.837 453.327 344.476L405.542 344.59C405.542 344.59 371.526 419.219 292.538 430.985C292.532 430.985 179.9 455.667 119.96 346.369Z",
    fill: "#2C44BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M441.435 227.153C441.435 227.153 383.32 110.436 249.478 156.568C249.478 156.568 196.282 174.374 172.172 227.37L211.72 227.542C211.714 227.542 314.829 80.2515 441.435 227.153Z",
    fill: "#2C44BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M451.474 225.631C451.474 225.631 421.53 110.602 271.254 116.734C271.254 116.734 164.913 123.163 118.106 227.524L165.891 227.41C165.891 227.41 199.908 152.781 278.896 141.015C278.896 141.015 391.528 116.333 451.474 225.631Z",
    fill: "#2C44BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogow);
export default __webpack_public_path__ + "static/media/logow.4b7f68caf2b33815c7cb943efd34cf08.svg";
export { ForwardRef as ReactComponent };